export default "__VITE_ASSET__CHjFsPwX__"